import { DayOfWeek } from 'api/ordering-service/ordering-service.types';

export const dayOfWeekMap: Record<DayOfWeek, string> = {
  SUNDAY: '0',
  MONDAY: '1',
  TUESDAY: '2',
  WEDNESDAY: '3',
  THURSDAY: '4',
  FRIDAY: '5',
  SATURDAY: '6',
};

export const DUMMY_EVENT_ID = 'DUMMY_EVENT_ID';
